import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _bookingPolicy = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
};
var _countBookingPoliciesRequest = {};
var _countBookingPoliciesResponse = {};
var _createBookingPolicyRequest = { bookingPolicy: '_bookingPolicy' };
var _createBookingPolicyResponse = { bookingPolicy: '_bookingPolicy' };
var _deleteBookingPolicyRequest = {};
var _deleteBookingPolicyResponse = {};
var _getBookingPolicyRequest = {};
var _getBookingPolicyResponse = { bookingPolicy: '_bookingPolicy' };
var _getStrictestBookingPolicyRequest = {};
var _getStrictestBookingPolicyResponse = { bookingPolicy: '_bookingPolicy' };
var _queryBookingPoliciesRequest = {};
var _queryBookingPoliciesResponse = { bookingPolicies: '_bookingPolicy' };
var _setDefaultBookingPolicyRequest = {};
var _setDefaultBookingPolicyResponse = {
    currentDefaultBookingPolicy: '_bookingPolicy',
    previousDefaultBookingPolicy: '_bookingPolicy',
};
var _updateBookingPolicyRequest = {
    mask: 'google.protobuf.FieldMask',
    bookingPolicy: '_bookingPolicy',
};
var _updateBookingPolicyResponse = { bookingPolicy: '_bookingPolicy' };
function resolveWixBookingsV1BookingPoliciesServiceUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/_api/bookings/v1/booking-policies',
                destPath: '/v1/booking-policies',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/bookings/v1/booking-policies',
                destPath: '/v1/booking-policies',
            },
        ],
        _: [
            {
                srcPath: '/_api/bookings/v1/booking-policies/strictest',
                destPath: '/v1/booking-policies/strictest',
            },
            {
                srcPath: '/_api/bookings/v1/booking-policies/query',
                destPath: '/v1/booking-policies/query',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Creates a booking policy. */
export function createBookingPolicy(payload) {
    var _a = serializer(_createBookingPolicyRequest, { _bookingPolicy: _bookingPolicy }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createBookingPolicyResponse, {
        _bookingPolicy: _bookingPolicy,
    }).fromJSON;
    function __createBookingPolicy(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v1.booking_policy',
            method: 'POST',
            methodFqn: 'wix.bookings.v1.BookingPoliciesService.CreateBookingPolicy',
            url: resolveWixBookingsV1BookingPoliciesServiceUrl({
                protoPath: '/v1/booking-policies',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createBookingPolicy.fromReq = fromReq;
    __createBookingPolicy.__isAmbassador = true;
    return __createBookingPolicy;
}
/** Retrieves a booking policy. */
export function getBookingPolicy(payload) {
    var _a = serializer(_getBookingPolicyRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getBookingPolicyResponse, {
        _bookingPolicy: _bookingPolicy,
    }).fromJSON;
    function __getBookingPolicy(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v1.booking_policy',
            method: 'GET',
            methodFqn: 'wix.bookings.v1.BookingPoliciesService.GetBookingPolicy',
            url: resolveWixBookingsV1BookingPoliciesServiceUrl({
                protoPath: '/v1/booking-policies/{bookingPolicyId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getBookingPolicy.fromReq = fromReq;
    __getBookingPolicy.__isAmbassador = true;
    return __getBookingPolicy;
}
/**
 * Retrieves the strictest version of each policy rule from a list of booking
 * policies.
 *
 *
 * Returns a hypothetical `bookingPolicy` object that combines the strictest
 * version of each rule. The `id` of the returned policy is `null` and no
 * corresponding `bookingPolicy` object is created. To create a new policy, you
 * can use [Create Booking Policy](https://dev.wix.com/docs/rest/business-solutions/bookings/services/booking-policy/create-booking-policy).
 */
export function getStrictestBookingPolicy(payload) {
    var _a = serializer(_getStrictestBookingPolicyRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getStrictestBookingPolicyResponse, {
        _bookingPolicy: _bookingPolicy,
    }).fromJSON;
    function __getStrictestBookingPolicy(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v1.booking_policy',
            method: 'POST',
            methodFqn: 'wix.bookings.v1.BookingPoliciesService.GetStrictestBookingPolicy',
            url: resolveWixBookingsV1BookingPoliciesServiceUrl({
                protoPath: '/v1/booking-policies/strictest',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getStrictestBookingPolicy.fromReq = fromReq;
    __getStrictestBookingPolicy.__isAmbassador = true;
    return __getStrictestBookingPolicy;
}
/**
 * Updates a booking policy.
 *
 *
 * Each time the booking policy is updated, `revision` increments by 1.
 * The current `revision` must be passed when updating the booking policy.
 * This ensures you're working with the latest booking policy and prevents unintended overwrites.
 */
export function updateBookingPolicy(payload) {
    var _a = serializer(_updateBookingPolicyRequest, { _bookingPolicy: _bookingPolicy }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateBookingPolicyResponse, {
        _bookingPolicy: _bookingPolicy,
    }).fromJSON;
    function __updateBookingPolicy(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v1.booking_policy',
            method: 'PATCH',
            methodFqn: 'wix.bookings.v1.BookingPoliciesService.UpdateBookingPolicy',
            url: resolveWixBookingsV1BookingPoliciesServiceUrl({
                protoPath: '/v1/booking-policies/{bookingPolicy.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateBookingPolicy.fromReq = fromReq;
    __updateBookingPolicy.__isAmbassador = true;
    return __updateBookingPolicy;
}
/**
 * Sets a booking policy as the default.
 *
 *
 * Also updates the site's current default policy by setting its `default`
 * attribute to `false`. If the provided policy is already the site's
 * default, the call succeeds without changing any `bookingPolicy` object.
 */
export function setDefaultBookingPolicy(payload) {
    var _a = serializer(_setDefaultBookingPolicyRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_setDefaultBookingPolicyResponse, {
        _bookingPolicy: _bookingPolicy,
    }).fromJSON;
    function __setDefaultBookingPolicy(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v1.booking_policy',
            method: 'POST',
            methodFqn: 'wix.bookings.v1.BookingPoliciesService.SetDefaultBookingPolicy',
            url: resolveWixBookingsV1BookingPoliciesServiceUrl({
                protoPath: '/v1/booking-policies/{bookingPolicyId}:setDefault',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __setDefaultBookingPolicy.fromReq = fromReq;
    __setDefaultBookingPolicy.__isAmbassador = true;
    return __setDefaultBookingPolicy;
}
/**
 * Deletes a booking policy.
 *
 *
 * You can't delete the default policy without
 * [setting a different policy as default](https://dev.wix.com/docs/rest/business-solutions/bookings/services/booking-policy/set-default-booking-policy)
 * first.
 */
export function deleteBookingPolicy(payload) {
    var _a = serializer(_deleteBookingPolicyRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteBookingPolicyResponse, {}).fromJSON;
    function __deleteBookingPolicy(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v1.booking_policy',
            method: 'DELETE',
            methodFqn: 'wix.bookings.v1.BookingPoliciesService.DeleteBookingPolicy',
            url: resolveWixBookingsV1BookingPoliciesServiceUrl({
                protoPath: '/v1/booking-policies/{bookingPolicyId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteBookingPolicy.fromReq = fromReq;
    __deleteBookingPolicy.__isAmbassador = true;
    return __deleteBookingPolicy;
}
/**
 * Retrieves a list of booking policies, given the provided paging, filtering, and sorting.
 *
 *
 * Query Booking Policies runs with these defaults, which you can override:
 *
 * - Sorted by `createdDate` in ascending order.
 * - `cursorPaging.limit` set to `100`.
 *
 * For details about all supported filters and sorting options, see
 * [the supported filters article](https://dev.wix.com/docs/rest/business-solutions/bookings/services/booking-policy/supported-filters).
 *
 * To learn about working with _Query_ endpoints, see
 * [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language),
 * [Sorting and Paging](https://dev.wix.com/api/rest/getting-started/pagination),
 * and [Field Projection](https://dev.wix.com/api/rest/getting-started/field-projection).
 */
export function queryBookingPolicies(payload) {
    var _a = serializer(_queryBookingPoliciesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryBookingPoliciesResponse, {
        _bookingPolicy: _bookingPolicy,
    }).fromJSON;
    function __queryBookingPolicies(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v1.booking_policy',
            method: 'POST',
            methodFqn: 'wix.bookings.v1.BookingPoliciesService.QueryBookingPolicies',
            url: resolveWixBookingsV1BookingPoliciesServiceUrl({
                protoPath: '/v1/booking-policies/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryBookingPolicies.fromReq = fromReq;
    __queryBookingPolicies.__isAmbassador = true;
    return __queryBookingPolicies;
}
/**
 * Counts booking policies, given the provided filtering.
 *
 *
 * See [the supported filters article](https://dev.wix.com/docs/rest/business-solutions/bookings/services/booking-policy/supported-filters)
 * for details.
 */
export function countBookingPolicies(payload) {
    var _a = serializer(_countBookingPoliciesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_countBookingPoliciesResponse, {}).fromJSON;
    function __countBookingPolicies(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.v1.booking_policy',
            method: 'POST',
            methodFqn: 'wix.bookings.v1.BookingPoliciesService.CountBookingPolicies',
            url: resolveWixBookingsV1BookingPoliciesServiceUrl({
                protoPath: '/v1/booking-policies/count',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __countBookingPolicies.fromReq = fromReq;
    __countBookingPolicies.__isAmbassador = true;
    return __countBookingPolicies;
}
//# sourceMappingURL=http.impl.js.map